import { makeAutoObservable } from "mobx";
import { ICalculatorFeeDto, ICalculatorItemBalanceDto, ICalculatorShippingCostDto, REFUND_METHODS } from "../components/refund-calculator-drawer/refund-calculator-types";
import RefundCalculatorLineStore from "./refund-calculator-line-store";
import { FONT_VARIANT } from "../../../../components/fonts/font-props";
import { TRISTATE_CHECKBOX_VALUES } from "../../../../components/inputs/tristate-checkbox/tristate-checkbox";


export interface ILinesSubtotal {
    price: number,
    tax: number,
}

class RefundCalculatorCategoryStore {
    
    private _title: string;
    private _lines: RefundCalculatorLineStore[];

    constructor (
        lines: (ICalculatorItemBalanceDto & ICalculatorShippingCostDto & ICalculatorFeeDto)[], 
        title: string, 
        paymentCurrency: string, 
        private _getProductName?: (v: number) => string,
        private _isSingleLine?: boolean,
    ) {
        this._title = title;
        this._lines = lines.map(line => new RefundCalculatorLineStore(line, paymentCurrency, this._getProductName));
        makeAutoObservable(this);
    }

    public get title(): string { return this._title; }
    public get lines(): RefundCalculatorLineStore[] { return this._lines; }
    /** For fee deduction lines */
    public get isSingleLine(): boolean { return !!this._isSingleLine; }

    public get checkedState(): TRISTATE_CHECKBOX_VALUES {
        if (this._lines.every(line => line.isSelected)) {
            return TRISTATE_CHECKBOX_VALUES.CHECKED;
        } 
        if (this._lines.some(line => line.isSelected)) {
            return TRISTATE_CHECKBOX_VALUES.PARTIALLY_CHECKED;
        }
        return TRISTATE_CHECKBOX_VALUES.UNCHECKED;
    }

    public setCheckedState(checked: TRISTATE_CHECKBOX_VALUES) {
        if (checked === TRISTATE_CHECKBOX_VALUES.UNCHECKED) {
            this._lines.forEach(line => line.setIsSelected(false));
        }
        else {
            this._lines.forEach(line => line.setIsSelected(true));
        }
    }

    public getLinesSubtotal(): ILinesSubtotal {
        const checkedLines = this._lines.filter(line => line.isSelected);
        const priceSubtotal = checkedLines.reduce((acc, line) => acc + line.amount, 0);
        const taxSubtotal = checkedLines.reduce((acc, line) => acc + line.tax, 0);
        return { price: priceSubtotal, tax: taxSubtotal };
    }

    public getTitleVariant(): FONT_VARIANT {
        if (this._lines.some(line => line.isSelected)) {
            return FONT_VARIANT.BOLD
        };
        return FONT_VARIANT.DEFAULT
    }

    public getUpdatedlines() {
        return this._lines.map(line => line.getUpdatedState());
    }

    public getAvailableAmountSubtotal(refundMethodType: REFUND_METHODS): number {
        const selectedLines = this._lines.filter(line => line.isSelected);
        const linesAvailableAmountList = selectedLines.map(line => line.getAvailableAmountSubtotal(refundMethodType));
        return linesAvailableAmountList.reduce((acc, amount) => acc + amount, 0);
    }
    
}

export default RefundCalculatorCategoryStore;